import React,{useContext,useState,useEffect} from 'react';
import { MyContext } from '../contexts/MyContext';
import {Link} from 'react-router-dom';
import {Oval} from 'react-loader-spinner';
import { FiArrowUp } from "react-icons/fi";
import logo from '../assets/img/logo.png';
import { WEB_URL_UPLOAD } from '../contexts/Apilinks';
import './Footer.css';
let BaseURLuploads = WEB_URL_UPLOAD;

function Footer() {
  const {addnewsletters} = useContext(MyContext);
    useEffect( () => {
        window.addEventListener('scroll', toggleVisibility);
      }, []);
    const getCurrentYear = () => {
      return new Date().getFullYear();
    };
    const [is_visible, set_visible] = useState(false);
    const scrollToTop =()=> {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
    const toggleVisibility =()=> {
      if (window.pageYOffset > 700) {
        set_visible(true);
      } else {
        set_visible(false);
      }
    }
   
    const [loadingsss, setloadingsss] = useState(false);
    const [isErrorMsg, setErrorMsg] = useState(null);
    const [isSuccessMsg, setSuccessMsg] = useState(null);
    const newsletteremails = async (event) =>{
      try{
        setloadingsss(true);
        event.preventDefault();
        event.persist();
        const data = await addnewsletters(newsletteruserInfo);
       if(data.success === true){
        setloadingsss(false);
        setSuccessMsg(data.msg);
        setnewsletteruserInfo({
          ...newsletteruserInfo,
          firstname: '',
          lastname:'',
          email:'',
          myinbox:'',
      });
       }else{
        setloadingsss(false);
        setErrorMsg(data.msg);
       }
      } catch (error) { throw error;} 
    }

    const [newsletteruserInfo, setnewsletteruserInfo] = useState({
      firstname: '',
      lastname:'',
      email:'',
      myinbox:'',
    });
    
    const onChangeValue = (e) => {
      setnewsletteruserInfo({
            ...newsletteruserInfo,
                [e.target.name]:e.target.value
        });
    } 



  return (
      <>

<div id="Footer" className="footer" >
  <div className="container">
    <div className="row">
    <div className="col-sm-12 col-md-12 col-lg-3 col-xl-3">
    <div className="header__logo">
            <Link to="/">
                <img src={logo} alt="logo" /> 
            </Link>
          </div>
   
    </div>
    <div className="col-sm-12 col-md-12 col-lg-9 col-xl-9">
    <div className="newsletter__content">
    
    <p> Subscribe to our newsletter</p>
    {isErrorMsg !== null && (<p className="errors__footersss"><>{isErrorMsg}</></p>)}
    {isSuccessMsg !== null && (<p className="success__footersss"><>{isSuccessMsg}</></p>)}
    <form onSubmit={newsletteremails} className="forms__nesss">
      <input type="email" name="email" value={newsletteruserInfo.email} onChange={onChangeValue} className="form-control" placeholder="Your Email Address..."  required />
      {loadingsss ? <>
        <Oval color="#f1592b" height={47} width={47} style={{float: "right"}}/>
      </> :
        <button type="submit" className="fotter__btnsss" >  Subscribe </button>
      } 
    </form>
  </div>
      <ul className="footer__links">
          <li><Link to={`/`}> Home </Link></li>
          <li><Link to={`/Books`}> Books </Link></li>
          <li><Link to={`/Interviews`}> Author Interview </Link></li>
          <li><Link to={`/Authors`}> Authors</Link></li>
          <li><Link to={`/Article`}> Articles </Link></li>
          <li><Link to={`/Poem`}> Poems </Link></li>
          <li><Link to={`/Contactus`}> Contact Us</Link></li>
        </ul>
      </div>
    
    <div className="clearfix"></div>
    {is_visible && ( <>
      <span onClick={scrollToTop} className="scrolls"> <FiArrowUp /> </span><span className="ltx-hex"><span className="ltx-hex-inner"></span></span>	
    </>)}
    </div>
  </div>
  <div className="col-md-12 ">
      <p className="fooccppss"> www.Iwordbooks(dot)com    |  <Link to="/"> Iwordbooks </Link> © All Rights Reserved - {getCurrentYear()} </p>
    </div>
</div>

        </>
  );
}

export default Footer;
